import type { EmployeeStatus, SyncStatus } from '../types'

export function StatusBadge({ status }: { status: EmployeeStatus }) {
  return <span className={`badge badge-${status}`}>{status === 'active' ? '正常' : '已停用'}</span>
}

export function SyncBadge({ status, error }: { status: SyncStatus; error?: string }) {
  const labels: Record<SyncStatus, string> = {
    synced: '已同步',
    pending: '待同步',
    error: '同步失败',
    mock: '本地模拟',
  }
  return (
    <span className={`badge badge-sync-${status}`} title={error || undefined}>
      {labels[status]}
    </span>
  )
}

